(ns manatee.components.modal.handlers
  (:require [manatee.components.modal.db :as db]
            [re-frame.core :as rf]))

(rf/reg-event-fx
 ::hide
 (fn hide
   [{:keys [db]} [_ modal-id]]
   {:db (-> db
            (db/hide modal-id)
            (db/set-modal-props nil))}))

(rf/reg-event-fx
 ::show
 (fn show
   [{:keys [db]} [_ modal-id modal-props]]
   {:db (cond-> (db/show db modal-id)
          modal-props (db/set-modal-props modal-props))}))
